
<template>
    <form action="/" method="POST" @submit.prevent="submit" novalidate>
        <slot></slot>
        <form-input-type-phone-number
            name="phone"
            :label="__('Enter your phone number')"
            :phoneCountry="phoneCountry"
            :errors="errors.phone"
        ></form-input-type-phone-number>

        <v-button :label="__('Verify email')" type="submit" size="lg" full-width></v-button>
    </form>
</template>

<script>
    export default {
        props: {
            phoneCountry: {
                type: String,
                required: true,
                default: 'cs'
            }
        },

        data() {
            return {
                errors: [],
            }
        },

        methods: {
            submit() {      
                let formData = {}

                $(this.$el)
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })
                
                axios
                    .post('/email/verify', formData)
                    .then((e) => {
                        window.location.replace("/email/verify-success")
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        Vuemit.fire('Button--sending-failed', true)
                    })
            }
        }
    }
</script>
